import type { LinhaDoFunil } from '@titularis/api-client';

type Canal = Partial<Pick<LinhaDoFunil, 'source' | 'medium' | 'campaign'>>;
type ContagensDaConversao = Pick<LinhaDoFunil, 'contas' | 'compras'>;
type TotaisDoFunil = Pick<LinhaDoFunil, 'contas' | 'inscricoes' | 'compras' | 'centavos'>;

/*
 * O pedido pode trazer só parte da atribuição. O mesmo rótulo atende à venda
 * e ao funil sem exigir campos que não foram medidos nem inventar um canal a
 * partir do referrer ou da página de chegada.
 */
export function rotuloDoCanal(origem: Canal | null | undefined): string {
  const partes = [origem?.source, origem?.medium, origem?.campaign].filter(Boolean);
  return partes.length > 0 ? partes.join(' / ') : 'Direto ou sem medição';
}

/*
 * Conta e compra podem pertencer a canais diferentes: limitar a 100% apagaria
 * essa diferença. Sem contas não há denominador, então zero seria uma taxa
 * inventada. A taxa fica numérica para ordenar sem perder casas decimais.
 */
export function calcularConversao(linha: ContagensDaConversao): number | null {
  return linha.contas === 0 ? null : linha.compras / linha.contas;
}

const formatoDaConversao = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export function formatarConversao(linha: ContagensDaConversao): string {
  const taxa = calcularConversao(linha);
  return taxa === null ? '-' : formatoDaConversao.format(taxa);
}

export function somarTotaisDoFunil(linhas: readonly LinhaDoFunil[]): TotaisDoFunil {
  return linhas.reduce<TotaisDoFunil>((totais, linha) => ({
    contas: totais.contas + linha.contas,
    inscricoes: totais.inscricoes + linha.inscricoes,
    compras: totais.compras + linha.compras,
    centavos: totais.centavos + linha.centavos,
  }), {
    contas: 0,
    inscricoes: 0,
    compras: 0,
    centavos: 0,
  });
}
